import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
import {
  PlayArrow,
  Close,
} from '@mui/icons-material';

interface SharePlayModalProps {
  open: boolean;
  songTitle: string;
  artist: string;
  onPlay: () => void;
  onCancel: () => void;
}

const SharePlayModal = ({ open, songTitle, artist, onPlay, onCancel }: SharePlayModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h6" component="span">
          Play Shared Song?
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          A song was shared with you from LiveShuffle:
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {songTitle}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {artist}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Your browser blocked automatic playback. Click Play to start listening!
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onCancel}
          startIcon={<Close />}
          sx={{ textTransform: 'none' }}
        >
          Cancel
        </Button>
        <Button
          onClick={onPlay}
          variant="contained"
          startIcon={<PlayArrow />}
          sx={{ textTransform: 'none' }}
        >
          Play
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SharePlayModal;
